const styles = theme => {
  return {
    noCrewMembersForLocation: {
      marginLeft: "10px",
      marginBottom: "10px",
      color: theme.palette.danger.main,
    },
    title: {
      backgroundColor: theme.palette.primary.dark,
    },
    white: {
      color: "#fff",
    },
    locationSelect: {
      marginTop: 16,
    },
    selectedDay: {
      fontWeight: "400",
    },
    unselectedDay: {
      color: "grey",
    },
    datePicker: {
      maxWidth: 200,
    },
    picker: {
      transform: "scale(0.8)",
    },
    morePadding: {
      paddingRight: 32,
      paddingLeft: 32,
    },
    addPosition: {
      color: "white",
    },
    boxSize: {
      width: "10px",
    },

    positionsWrapper: {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: {
        flexWrap: "wrap",
        justifyContent: "center",
      },
    },
    boxWrapper: {
      display: "flex",
      marginTop: "10px",
    },
    closeIcon: {
      color: theme.palette.primary.main,
      backgroundColor: "white",
    },
    closeAvatar: {
      backgroundColor: "white",
      border: `2px solid ${theme.palette.primary.main}`,
      cursor: "pointer",
    },
    profile_image: {
      width: "100%",
      height: 100,
    },
    defaultCrewCard: {
      minWidth: 200,
      //overflow: "visible",
      display: "inline-block",
      marginRight: "32px",
      position: "relative",
    },
    removeDefaultCrewIcon: {
      color: "white",
    },
    overlay: {
      position: "fixed",
      display: "block",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 2,
    },
    crewSectionWrapper: {
      display: "flex",
      flexWrap: "wrap",
      marginTop: theme.spacing(4),
      width: "90%",
    },
    crewCardWrapper: {
      // marginBottom: theme.spacing(2),
      position: "relative",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    contentWrapper: {
      flexGrow: 1,
    },
    iconColor: {
      color: "#5c9588",
    },
    overlayImage: {
      color: "#d0eee0",
    },
    alignCenter: {
      textAlign: "center",
    },
    alignSelf: {
      alignSelf: "center",
    },
    padding: {
      padding: theme.spacing(1),
    },
    backgroundLight: {
      backgroundColor: "#f6f6fe",
      height: "auto",
      paddingTop: "5px",
      display: "flex",
      maxWidth: "fit-content",
    },
    defaultCrewSlate: {
      height: "auto",
      paddingTop: "5px",
      display: "flex",
      backgroundColor: "#f6f6fe",
      padding: theme.spacing(2),
    },
    defaultCrewInfo: {
      // padding: theme.spacing(2),
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      alignItems: "center",
    },
    positionAbsolute: {
      position: "absolute",
      width: "35px",
      height: "35px",
    },
    noteLineTextCrew: {
      fontSize: "0.9rem",
    },
    noteLineTextDefaultCrew: {
      fontSize: "1rem",
      fontWeight: 600,
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.9rem",
        fontWeight: 400,
      },
    },
    positionText: {
      fontSize: "0.7rem",
      fontWeight: 800,
    },
    noPositionText: {
      fontSize: "0.8rem",
      opacity: 0.5,
      fontWeight: 500,
    },
    marginLeft: {
      marginLeft: theme.spacing(5),
    },
    Icon: {
      alignSelf: "center",
      marginRight: theme.spacing(4),
      marginLeft: theme.spacing(4),
      cursor: "pointer",
    },
    SelectPositionIcon: {
      alignSelf: "center",
      marginRight: theme.spacing(1.5),
      marginLeft: theme.spacing(1.5),
      cursor: "pointer",
    },
    margin: {
      margin: theme.spacing(3),
    },
    crewDialog: {
      width: "90%",
      [theme.breakpoints.down("sm")]: {
        width: "auto",
      },
    },
    PositionInfo: {
      flexDirection: "row",
    },
    selectedCrewMember: {
      opacity: "0.5",
      backgroundColor: "#bdddd3",
    },
    selectedCrewMemberCheck: {
      position: "absolute",
      left: "45%",
      top: "45%",
      // -webkit-transform: translate(-50%, -50%);
      // -moz-transform: translate(-50%, -50%);
      transform: `translate(-50%px, -50%px)`,
    },
    selectingCrewMemberLoader: {
      position: "absolute",
      left: "45%",
      transform: `translate(-50%px, -50%px)`,
    },
    selectingCrewMember: {
      opacity: "0.5",
      backgroundColor: "#0cdaff",
    },
    pointer: {
      cursor: "pointer",
    },
    formControl: {
      minWidth: "200px",
      fontSize: "small",
    },
    chip: {
      backgroundColor: theme.palette.primary.main,
      margin: theme.spacing(1),
      color: "#fff",
      marginTop: 12,
      // borderRadius: 'unset'
    },
    chipDeleteIcon: {
      color: "#fff",
    },
    chipAddIcon: {
      color: "#fff",
      cursor: "pointer",
    },
    controls: {
      backgroundColor: theme.palette.primary.main,
      margin: theme.spacing(1),
      color: "#fff",
      marginTop: 12,
      borderRadius: theme.spacing(2),
      width: "1.1em",
      height: "1.1em",
      cursor: "pointer",
    },
    scrollControls: {
      backgroundColor: theme.palette.primary.main,
      margin: theme.spacing(1),
      color: "#fff",
      marginTop: 12,
      maxWidth: "fit-content",
      display: "flex",
      borderRadius: theme.spacing(3),
      padding: "5px",
    },
    scrollControlsText: {
      fontSize: "0.75rem",
      lineHeight: "1.8",
    },
    positionSlide: {
      padding: "10px",
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      height: "fit-content",
      backgroundColor: "#fbe6aa",
    },
    positionSlideMobile: {
      padding: "10px",
      backgroundColor: "#fbe6aa",
    },
    newShootTitle: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "auto",
      [theme.breakpoints.down("sm")]: {
        width: "auto",
      },
    },
    MenuHeight: {
      height: "30%",
      padding: "10px",
    },
  }
}

export default styles
